// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"ec3164b7","239":"e4a02aec","453":"85e2ed9f","455":"56f02a37","977":"39f1e3d9"}[chunkId] + ".chunk.js";
};